import { IPopupModel } from '@mwe/models';

export const LOGOUT_POPUP: IPopupModel = {
  id: 'profile-logout',
  titleKey: 'global.logoutPopup.title',
  messageKey: 'global.logoutPopup.message',
  showSubmitButton: true,
  submitButtonKey: 'global.logout',
  showCancelButton: true,
  cancelButtonKey: 'global.cancel',
};

export const FORBIDDEN_POPUP: IPopupModel = {
  id: 'user-register-forbidden',
  titleKey: 'global.errors.forbidden.title',
  messageKey: 'global.errors.forbidden.errorMessage',
  showSubmitButton: true,
  submitButtonKey: 'global.errors.forbidden.logoutButtonText',
  dismissable: false,
};

export function createDynamicErrorPopup(id: string, titleKey: string, messageKey?: string): IPopupModel {
  return {
    id,
    titleKey,
    messageKey: messageKey || 'global.errors.defaultErrorMessage',
    showSubmitButton: true,
    submitButtonKey: 'OK',
    showCancelButton: false,
    iconColorClass: 'red',
    iconTypeClass: 'fa-bell',
  };
}
